import { render, staticRenderFns } from "./HelpVideos.vue?vue&type=template&id=51d637f1&scoped=true"
import script from "./HelpVideos.vue?vue&type=script&lang=js"
export * from "./HelpVideos.vue?vue&type=script&lang=js"
import style0 from "./HelpVideos.vue?vue&type=style&index=0&id=51d637f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d637f1",
  null
  
)

export default component.exports